import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/admin", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Inloggen mislukt.");
      setLoading(false);
    }
  };

  const inputCls = "w-full rounded-xl border border-cc-border bg-cc-panel2 px-4 py-3 font-body text-cc-ink placeholder:text-cc-faint focus:outline-none focus:ring-2 focus:ring-cc-accent/40 focus:border-cc-accent transition";

  return (
    <div className="min-h-screen bg-cc-bg flex items-center justify-center px-5 relative overflow-hidden">
      <div className="pointer-events-none absolute -top-32 -left-32 w-[460px] h-[460px] rounded-full bg-cc-accent/20 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-40 -right-24 w-[420px] h-[420px] rounded-full bg-cc-pos/10 blur-[120px]" />
      <div className="relative w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-flex items-center justify-center w-12 h-12 rounded-2xl bg-cc-accent text-white font-heading font-extrabold text-xl mb-4">V</span>
          <p className="font-heading font-extrabold text-3xl tracking-tight text-cc-ink">
            VHM <span className="text-cc-accent">Renovation</span>
          </p>
          <p className="mt-2 font-body text-xs text-cc-faint uppercase tracking-[0.25em]">Command Center</p>
        </div>
        <form onSubmit={submit} data-testid="login-form" className="rounded-2xl bg-cc-panel border border-cc-border p-8 shadow-2xl">
          <div className="flex items-center gap-2 mb-6">
            <Lock className="w-5 h-5 text-cc-accent" />
            <h1 className="font-heading font-bold text-xl text-cc-ink">Beveiligde login</h1>
          </div>
          <label className="block font-body text-sm font-medium text-cc-sub mb-2">E-mailadres</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className={`${inputCls} mb-5`}
            placeholder="admin@vhmconstructionrenovation.be"
          />
          <label className="block font-body text-sm font-medium text-cc-sub mb-2">Wachtwoord</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className={`${inputCls} mb-7`}
            placeholder="••••••••"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full inline-flex items-center justify-center gap-2 rounded-xl bg-cc-accent text-white px-6 py-3.5 font-body font-semibold hover:bg-cc-accenth transition-colors disabled:opacity-60"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null}
            Inloggen
          </button>
        </form>
      </div>
    </div>
  );
}
